import { LegalLayout } from "./LegalLayout";
import { CONTACT_BLOCK, LegalSection } from "./shared";

const { H2, P, UL } = LegalSection;

export default function Cookies() {
  return (
    <LegalLayout title="Política de Cookies" updated="agosto de 2026">
      <H2>1. O que são cookies</H2>
      <P>
        Cookies são pequenos ficheiros de texto armazenados no seu dispositivo (computador, tablet
        ou smartphone) quando visita um website. Permitem, entre outras funções, recordar
        preferências, compreender como o site é utilizado e melhorar a experiência de navegação.
      </P>

      <H2>2. Cookies utilizados atualmente neste website</H2>
      <P>
        Atualmente, o website da TopEstofos utiliza apenas cookies e tecnologias estritamente
        necessárias ao seu funcionamento técnico e à segurança da navegação. Estes cookies não
        recolhem informação para fins de marketing nem permitem identificar diretamente o utilizador.
      </P>

      <H2>3. Cookies de análise e de marketing (futura utilização)</H2>
      <P>
        A TopEstofos prevê a futura instalação de ferramentas de análise e de publicidade, como
        Google Analytics 4, Google Ads, Google Tag Manager e Meta Pixel. Quando essas ferramentas
        forem implementadas, poderão ser utilizados cookies das seguintes categorias:
      </P>
      <UL>
        <li>
          <strong className="text-navy">Cookies de análise e desempenho</strong> — permitem medir
          visitas, páginas mais vistas e interações, ajudando-nos a melhorar o website (ex.: Google
          Analytics 4);
        </li>
        <li>
          <strong className="text-navy">Cookies de publicidade e remarketing</strong> — permitem
          medir a eficácia de campanhas e apresentar anúncios relevantes (ex.: Google Ads, Meta
          Pixel);
        </li>
        <li>
          <strong className="text-navy">Cookies de gestão de ferramentas</strong> — associados ao
          Google Tag Manager, que facilita a gestão das restantes ferramentas.
        </li>
      </UL>
      <P>
        Estes cookies de análise e de marketing <strong className="text-navy">só serão ativados
        mediante o seu consentimento prévio</strong>, através de um aviso/banner de cookies que será
        apresentado no website quando essas ferramentas forem instaladas. Até lá, nenhum cookie
        destas categorias será colocado no seu dispositivo.
      </P>

      <H2>4. Gestão e desativação de cookies</H2>
      <P>
        Pode, a qualquer momento, configurar o seu navegador para aceitar, recusar ou eliminar
        cookies. Tenha em conta que a desativação de cookies estritamente necessários pode afetar o
        funcionamento correto do website. As instruções de gestão de cookies encontram-se nas
        definições do seu navegador (por exemplo, Chrome, Firefox, Safari ou Edge).
      </P>
      <P>
        Quando o sistema de consentimento de cookies estiver implementado, poderá também alterar ou
        retirar o seu consentimento diretamente no website, de forma simples e a qualquer momento.
      </P>

      <H2>5. Alterações a esta política</H2>
      <P>
        Esta Política de Cookies será atualizada quando forem instaladas as ferramentas de análise
        e marketing referidas, passando a identificar de forma detalhada cada cookie utilizado, a
        respetiva finalidade e duração. A versão em vigor estará sempre disponível nesta página.
      </P>

      {CONTACT_BLOCK}
    </LegalLayout>
  );
}
